import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAdvList as _getAdvList, getMarketList as _getMarketList, getPersonCenter as _getPersonCenter } from '../../api/index';
import AdvSet from './advSet';
import MarketSet from './marketSet';
import PersonalCenter from './personalCenter';
import styleConfig from '@/views/custom-layout/styleConfig';
import decorIndex from '@/views/custom-layout/index';
import category from '@/views/custom-layout/category';
import adjustRule from './adjustRule';
import KefuAdjustRules from '@/views/serviceCenter/workBench/components/kefuAdjustRules.vue';
import CustomerPriceAdjustmentRulesList from '@/views/cardSystem/customer/components/customerPriceAdjustmentRulesList.vue';
import { getGoodsAdjustRuleList, getMenusAdjustRuleList } from '@/views/cardSystem/customer/api';
export default {
  name: 'customerSet',
  components: {
    CustomerPriceAdjustmentRulesList: CustomerPriceAdjustmentRulesList,
    KefuAdjustRules: KefuAdjustRules,
    AdvSet: AdvSet,
    MarketSet: MarketSet,
    PersonalCenter: PersonalCenter,
    styleConfig: styleConfig,
    decorIndex: decorIndex,
    category: category,
    adjustRule: adjustRule
  },
  props: {
    module: {
      type: String,
      default: 'service_custom'
    },
    customerData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      activeName: '5',
      advSet: {},
      marketSet: {},
      movieList: {
        movie: '',
        cinema: ''
      },
      personData: {},
      goodsData: [],
      menuData: []
    };
  },
  methods: {
    // tab是否显示权限url
    rolePath: function rolePath(current) {
      return {
        1: {
          service_custom: '/kefu/decoration/shop-config-by-customer',
          plat_service_custom: '/plat-service/decoration/shop-config-by-customer'
        },
        2: {
          service_custom: '/kefu/decoration/home-by-customer',
          plat_service_custom: '/plat-service/decoration/home-by-customer'
        },
        3: {
          service_custom: '/kefu/decoration/menus-home-by-customer',
          plat_service_custom: '/plat-service/decoration/menus-home-by-customer'
        },
        4: {
          service_custom: '/kefu/customer-account-new/get-customer-account-extend',
          plat_service_custom: '/plat-service/customer-account/get-customer-account-extend'
        },
        5: {
          service_custom: '/kefu/customer-account-new/get-customer-account-marketing',
          plat_service_custom: '/plat-service/customer-account/get-customer-account-marketing'
        },
        6: {
          service_custom: '/kefu/customer-account-new/get-customer-account-center',
          plat_service_custom: '/plat-service/customer-account/get-customer-account-center'
        },
        7: {
          service_custom: '/customer/customer-account-new/adjust-rule',
          plat_service_custom: '/customer/customer-account-new/adjust-rule'
        }
      }[current][this.module];
    },
    changeTabs: function changeTabs() {
      if (this.activeName === '4') {
        this.getAdvList();
      } else if (this.activeName === '5') {
        this.getMarketList();
      } else if (this.activeName === '6') {
        this.getPersonCenter();
      } else if (this.activeName === '7') {
        this.getRules();
      }
    },
    getRules: function getRules() {
      var params = {
        customer_id: this.customerData.customer_id,
        account_id: this.customerData.account_id,
        uid: this.customerData.uid
      };
      this.getGoodRule(params);
      this.getMenuRule(params);
    },
    // 获取调价规则商品中心
    getGoodRule: function getGoodRule(params) {
      var _this = this;
      getGoodsAdjustRuleList(params).then(function (res) {
        _this.goodsData = res.data;
      });
    },
    // 获取调价规则菜单管理
    getMenuRule: function getMenuRule(params) {
      var _this2 = this;
      getMenusAdjustRuleList(params).then(function (res) {
        _this2.menuData = res.data;
      });
    },
    init: function init() {
      var activeName = '1';
      if (this.$hasBtnRoles(this.rolePath(1))) {
        activeName = '1';
      } else if (this.$hasBtnRoles(this.rolePath(2))) {
        activeName = '2';
      } else if (this.$hasBtnRoles(this.rolePath(3))) {
        activeName = '3';
      } else if (this.$hasBtnRoles(this.rolePath(4))) {
        activeName = '4';
      } else if (this.$hasBtnRoles(this.rolePath(5))) {
        activeName = '5';
      } else if (this.$hasBtnRoles(this.rolePath(6))) {
        activeName = '6';
      } else if (this.$hasBtnRoles(this.rolePath(7))) {
        activeName = '7';
      }
      this.activeName = activeName || '1';
      this.changeTabs();
    },
    // 获取高级设置
    getAdvList: function getAdvList() {
      var _this3 = this;
      var params = {
        customer_id: this.customerData.customer_id,
        customer_account_id: this.customerData.account_id
      };
      _getAdvList(this.module, params).then(function (res) {
        _this3.advSet = res.data;
      });
    },
    // 获取营销参数设置
    getMarketList: function getMarketList() {
      var _this4 = this;
      var params = {
        customer_id: this.customerData.customer_id,
        customer_account_id: this.customerData.account_id
      };
      _getMarketList(this.module, params).then(function (res) {
        var _res$data, _res$data$drf_smg_com, _res$data2, _res$data2$drf_smg_co, _res$data3, _res$data3$drf_smg_co;
        _this4.marketSet = _objectSpread(_objectSpread({}, res.data), {}, {
          hm_goods_detail_customize: {
            hm_rule_type: Number(res.data.hm_rule_type),
            hm_tip_content: res.data.hm_tip_content,
            hm_default_tip_content: res.data.hmcs_channel_tip_content
          },
          drf_smg_goods_detail_customize: {
            drf_smg_rule_type: Number(res.data.drf_smg_rule_type),
            drf_smg_tip_content: res.data.drf_smg_tip_content,
            drf_smg_default_tip_content: res.data.drf_smg_channel_tip_content
          },
          DrfSmgCompany: {
            accountConfig: ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$drf_smg_com = _res$data.drf_smg_company_code_config) === null || _res$data$drf_smg_com === void 0 ? void 0 : _res$data$drf_smg_com.accountConfig) || {},
            channelConfig: ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$drf_smg_co = _res$data2.drf_smg_company_code_config) === null || _res$data2$drf_smg_co === void 0 ? void 0 : _res$data2$drf_smg_co.channelConfig) || {},
            list: ((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : (_res$data3$drf_smg_co = _res$data3.drf_smg_company_code_config) === null || _res$data3$drf_smg_co === void 0 ? void 0 : _res$data3$drf_smg_co.list) || []
          }
        });
        if (res.data.black_movies.length > 2) {
          _this4.movieList.movie = res.data.black_movies[0].movie_name + '、' + res.data.black_movies[1].movie_name + '...';
        } else if (res.data.black_movies.length === 2) {
          _this4.movieList.movie = res.data.black_movies[0].movie_name + '、' + res.data.black_movies[1].movie_name;
        } else if (res.data.black_movies.length === 1) {
          _this4.movieList.movie = res.data.black_movies[0].movie_name;
        } else {
          _this4.movieList.movie = '';
        }
        if (res.data.black_cinema.length > 2) {
          _this4.movieList.cinema = res.data.black_cinema[0].cinema_name + '、' + res.data.black_cinema[1].cinema_name + '...';
        } else if (res.data.black_cinema.length === 2) {
          _this4.movieList.cinema = res.data.black_cinema[0].cinema_name + '、' + res.data.black_cinema[1].cinema_name;
        } else if (res.data.black_cinema.length === 1) {
          _this4.movieList.cinema = res.data.black_cinema[0].cinema_name;
        } else {
          _this4.movieList.cinema = '';
        }
      });
    },
    // 获取个人中心信息
    getPersonCenter: function getPersonCenter() {
      var _this5 = this;
      var params = {
        customer_id: this.customerData.customer_id,
        customer_account_id: this.customerData.account_id
      };
      _getPersonCenter(this.module, params).then(function (res) {
        _this5.personData = res.data;
      });
    }
  },
  created: function created() {
    this.init();
  },
  computed: {
    decorInfo: function decorInfo() {
      var _this$customerData = this.customerData,
        channel_id = _this$customerData.channel_id,
        customer_id = _this$customerData.customer_id,
        customer_name = _this$customerData.customer_name;
      return {
        module: this.module,
        channel_id: channel_id,
        customer_id: customer_id,
        customer_name: customer_name
      };
    }
  }
};